import { render, staticRenderFns } from "./ReturnPhotoTypes.vue?vue&type=template&id=8667f9ea&scoped=true&"
import script from "./ReturnPhotoTypes.vue?vue&type=script&lang=js&"
export * from "./ReturnPhotoTypes.vue?vue&type=script&lang=js&"
import style0 from "./ReturnPhotoTypes.vue?vue&type=style&index=0&id=8667f9ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8667f9ea",
  null
  
)

export default component.exports